import access from './access'

export default [
  ...access,
]
